import { DateTime } from "luxon";
import {
  TRAIN_FILTERS_CHANGE,
  TRAIN_FILTERS_RESET,
  TRAIN_FILTERS_UPDATE,
  TRAIN_SEARCH_FORM_RESET,
  TRAIN_SEARCH_FORM_UPDATE,
  TRAIN_SEARCH_RESULTS_CHANGE,
  TRAIN_SEARCH_RESULTS_IDLE,
  TRAIN_SEARCH_RESULTS_LOADING,
  TRAIN_SEARCH_RESULTS_RESET,
  TRAIN_SEARCH_RESULTS_UPDATE,
  TRAIN_SINGLE_FILTER_RESET,
} from "../actions/search/types";
import { trainPax } from "../components/MainSearchForm/modals";

const TrainSearchFormInitial = {
  adults: 2,
  adults_ages: new Array(2).fill(trainPax.adults.from),
  seniors: 0,
  seniors_ages: [],
  youths: 0,
  youths_ages: [],
  departDateTime: DateTime.now()
    .plus({ days: 1 })
    .toFormat("yyyy-MM-dd'T'HH:mm:ss"),
  returnDateTime: DateTime.now()
    .plus({ days: 7 })
    .toFormat("yyyy-MM-dd'T'HH:mm:ss"),

  hasReturn: false,
  origin: {},
  destination: {},
  searchPayload: {},
};
export const TrainSearchForm = (state = TrainSearchFormInitial, action) => {
  switch (action.type) {
    case TRAIN_SEARCH_FORM_UPDATE: {
      const { form } = action;
      return { ...state, ...form };
    }
    case TRAIN_SEARCH_FORM_RESET: {
      return TrainSearchFormInitial;
    }
    default:
      return state;
  }
};

const TrainSearchResultsInitial = {
  trains: [],
  loading: true,
  failed: false,
};
export const TrainSearchResults = (
  state = TrainSearchResultsInitial,
  action
) => {
  switch (action.type) {
    case TRAIN_SEARCH_RESULTS_LOADING: {
      return { ...state, loading: true };
    }
    case TRAIN_SEARCH_RESULTS_IDLE: {
      return { ...state, loading: false };
    }
    case TRAIN_SEARCH_RESULTS_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case TRAIN_SEARCH_RESULTS_UPDATE: {
      const { results } = action;
      return { ...state, ...results };
    }
    case TRAIN_SEARCH_RESULTS_RESET: {
      return TrainSearchResultsInitial;
    }
    default:
      return state;
  }
};

export const TrainFiltersInitial = {
  budget: [0, 1],
  order_by: "DPD",
};
export const TrainFilters = (state = TrainFiltersInitial, action) => {
  switch (action.type) {
    case TRAIN_FILTERS_RESET: {
      return TrainFiltersInitial;
    }
    case TRAIN_SINGLE_FILTER_RESET: {
      const { key } = action;
      return { ...state, [key]: TrainFiltersInitial[key] };
    }
    case TRAIN_FILTERS_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case TRAIN_FILTERS_UPDATE: {
      const { filters } = action;
      return { ...state, ...filters };
    }
    default:
      return state;
  }
};
